const initialState = {
  edgeIneligible: null,
  creditIneligibleClicked: '',
};

function edgeIneligible(state = initialState, action) {
  switch (action.type) {
    case 'RUN_CREDIT_REVIEW_SUCCESS_RESPONSE':
      return { ...state, creditedgeInEligible: action.response };
    case 'CREDIT_INELIGIBLE_CLICKED':
      return { ...state, creditIneligibleClicked: action.data };
    default:
      return state;
  }
}

export default edgeIneligible;
